<template>
    <administrative>

        <card-header :title="'Branch: '+branch.title+' - '+branch.code"/>
        <div class="gap-4">
            <div class="p-6 bg-white border-b border-gray-200  shadow-sm sm:rounded-lg ">
                <loading :showLoading="selectform.processing"/>

                <div :class="{'opacity-50':selectform.processing,'opacity-100':!selectform.processing}">
                    <p class="text-lg font-medium mb-4">Branch Teachers</p>
                    <form @submit.prevent="assignFaculties">
                        <div class="divide-y ">
                            <div
                                class="flex flex-wrap gap-4  mb-6 pt-6"
                                v-for="(user,index) in selectform.faculties"
                                :key="index"
                            >
                                <div class="">

                                    <FormMultiselect
                                        class="w-96"
                                        :disabled="user?.old_id"
                                        :options="newFaculties"
                                        track-key="id"
                                        label-key="title"
                                        :object="true"
                                        v-model="selectform.faculties[index].faculties"
                                        :placeholder="'Select faculties'"
                                        :error="selectform.errors?.addUser?selectform.errors?.addUser[`faculties.${index}.faculties`]:''"
                                    />
                                </div>

                                <div class="">


                                    <FormMultiselect
                                        class="w-56"
                                        :disabled="user?.old_id&& !user.department.id==''"
                                        :options="departments"
                                        track-key="id"
                                        label-key="name"
                                        :object="true"
                                        v-model="selectform.faculties[index].department"
                                        :placeholder="'Select Department'"
                                        :error="selectform.errors?.addUser?selectform.errors?.addUser[`faculties.${index}.department`]:''"

                                    />

                                </div>
                                <div class="">
                                    <FormMultiselect
                                        class="w-56"
                                        :options="designations"
                                        :disabled="user?.old_id&& !user.designation.id==''"
                                        track-key="id"
                                        label-key="name"
                                        :object="true"
                                        v-model="selectform.faculties[index].designation"
                                        :placeholder="'Select Designations'"
                                        :error="selectform.errors?.addUser?selectform.errors?.addUser[`faculties.${index}.designation`]:''"

                                    />

                                </div>
                                <div class="">

                                    <FormMultiselect
                                        class="w-56"
                                        :options="durationOptions"
                                        :disabled="user?.old_id&& !user.duration.id==''"
                                        track-key="id"
                                        label-key="title"
                                        :object="true"
                                        v-model="selectform.faculties[index].duration"
                                        :placeholder="'Select Duration'"
                                        :error="selectform.errors?.addUser?selectform.errors?.addUser[`faculties.${index}.duration`]:''"
                                    />

                                </div>
                                <div class="">


                                    <FormMultiselect
                                        class="w-56"
                                        :options="datesOptions"
                                        :disabled="user?.old_id&& !user.year.id==''"
                                        track-key="id"
                                        label-key="title"
                                        :object="true"
                                        v-model="selectform.faculties[index].year"
                                        :placeholder="'Select Year'"
                                        :error="selectform.errors?.addUser?selectform.errors?.addUser[`faculties.${index}.year`]:''"
                                    />

                                </div>
                                <div class="flex justify-between items-center w-48">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                             class="h-6 w-6 text-red-500 justify-self-center cursor-pointer"
                                             viewBox="0 0 20 20"
                                             fill="currentColor"
                                             @click="removeFaculty(index,user?.old_id)">
                                            <path fill-rule="evenodd"
                                                  d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                  clip-rule="evenodd"
                                            />
                                        </svg>

                                    </div>
                                    <div v-if="user?.id_card">
                                        <breeze-button @click="deleteIdCard(user)" type="button">delete id card
                                        </breeze-button>
                                    </div>
                                </div>
                                <hr class="col-span-8"/>
                                <!-- <div></div> -->
                            </div>

                        </div>
                        <div class="flex space-x-2">
                            <breeze-button :type="'button'" class="" @click="addFaculty">Add</breeze-button>
                            <div>
                                <button-link
                                    :href="route('administrative.branch.list')"
                                    class="bg-red-500 hover:bg-red-400"
                                >Cancel
                                </button-link>
                            </div>
                            <breeze-button :disabled="form.processing">Next</breeze-button>
                        </div>

                        <exception/>
                    </form>
                </div>
            </div>
            <div
                class="p-6 mt-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg col-span-2"
            >
                <loading :showLoading="form.processing"/>
                <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                    <p class="text-lg font-medium mb-4">Add Teacher</p>
                    <form @submit.prevent="submitForm">
                        <div class="grid grid-cols-8 gap-4 mb-4">
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'First Name'"/>
                                <breeze-input required v-model="form.first_name" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.first_name:''"
                                />
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'Middle Name'"/>
                                <breeze-input required v-model="form.middle_name" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.middle_name:''"
                                />
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'Last Name'"/>
                                <breeze-input required v-model="form.last_name" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.last_name:''"
                                />
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'Mobile No'"/>
                                <breeze-input required type="number" v-model="form.mobile" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.mobile:''"
                                />
                            </div>
                            <div class="col-span-6 sm:col-span-6">
                                <breeze-label :required="true" :value="'Email Id'"/>
                                <breeze-input required type="email" v-model="form.email" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.email:''"
                                />
                            </div>
                            <div class="grid grid-cols-2 w-full col-span-2">
                                <div class>
                                    <breeze-label :value="'Male'"/>
                                    <input-checkbox
                                        required
                                        type="radio"
                                        class="rounded-full"
                                        name="gender"
                                        :value="'male'"
                                        v-model="form.gender"
                                    />
                                </div>
                                <div class>
                                    <breeze-label :value="'Female'"/>
                                    <input-checkbox
                                        required
                                        type="radio"
                                        value="female"
                                        class="rounded-full"
                                        name="gender"
                                        v-model="form.gender"
                                    />
                                </div>
                                <div class="col-span-2">
                                    <breeze-input-error
                                        :message="form.errors.addFaculty?form.errors.addFaculty.gender:''"
                                    />
                                </div>
                            </div>
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Address Line 1'"/>
                                <breeze-input :required="true" required v-model="form.address_line_1" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.address_line_1:''"
                                />
                            </div>
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :value="'Address Line 2'"/>
                                <breeze-input v-model="form.address_line_2" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.address_line_2:''"
                                />
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'Landmark'"/>
                                <breeze-input v-model="form.landmark" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.landmark:''"
                                />
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'City'"/>
                                <breeze-input v-model="form.city" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.city:''"
                                />
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'State'"/>
                                <breeze-input v-model="form.state" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.state:''"
                                />
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'Pincode'"/>
                                <breeze-input v-model="form.pincode" type="number" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.pincode:''"
                                />
                            </div>

                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :value="'Date Of Birth'"/>
                                <breeze-input v-model="form.date_of_birth" type="date" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.date_of_birth:''"
                                />
                            </div>

                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :value="'Blood Group'"/>
                                <breeze-input v-model="form.blood_group" type="text" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.blood_group:''"
                                />
                            </div>

                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Regular'"/>
                                <input-checkbox
                                    required
                                    type="radio"
                                    value="regular"
                                    class="rounded-full"
                                    name="type"
                                    v-model="form.type"
                                />
                                <breeze-input-error
                                    :message="form.errors.addFaculty?form.errors.addFaculty.type:''"
                                />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Visiting'"/>
                                <input-checkbox
                                    required
                                    type="radio"
                                    value="visiting"
                                    class="rounded-full"
                                    name="type"
                                    v-model="form.type"
                                />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                     <ProfileImageComponent
                                    required
                                    v-model="form.image"
                                    :error-message="form.errors?.image"/>
                            </div>
                        </div>
                        <button-link
                            :href="route('administrative.branch.list')"
                            class="bg-red-500 mr-4 hover:bg-red-400"
                        >Cancel
                        </button-link>
                        <breeze-button :disabled="form.processing">Save</breeze-button>
                        <exception/>
                    </form>
                </div>
            </div>

        </div>
    </administrative>
</template>

<script>
import Administrative from "@/Pages/Administrative/Administrative";
import BreezeTable from "@/Components/Table";
import BreezeInput from "@/Components/Input";
import InputCheckbox from "@/Components/InputCheckbox";
import BreezeLabel from "@/Components/Label";
import BreezeButton from "@/Components/Button";
import BreezeInputError from "@/Components/InputError";
import ButtonLink from "@/Components/ButtonLink";
import SelectList from "@/Components/SelectList";
import Exception from "@/Components/Exception";
import {useForm} from "@inertiajs/inertia-vue3";
import CardHeader from "@/Components/CardHeader";
import Loading from "@/Components/Loading";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import ProfileImageComponent from "@/Components/ProfileImageComponent.vue";


export default {
    components: {
        ProfileImageComponent,
        FormMultiselect,
        Administrative,
        BreezeTable,
        ButtonLink,
        Exception,
        BreezeInputError,
        BreezeInput,
        BreezeLabel,
        BreezeButton,
        SelectList,
        InputCheckbox,
        CardHeader,
        Loading
    },
    props: ["branch", "faculties", "departments", "designations", 'duration', 'dates'],
    data() {
        return {
            form: useForm(
                {
                    first_name: "",
                    middle_name: "",
                    last_name: "",
                    mobile: "",
                    email: "",
                    gender: "",
                    address_line_1: "",
                    address_line_2: "",
                    landmark: "",
                    city: "",
                    pincode: "",
                    state: "",
                    type: "",
                    image: "",
                    date_of_birth: ""
                },
                {
                    errorBag: "addFaculty"
                }
            ),

            selectform: useForm(
                {
                    _method: "PUT",
                    faculties: []
                },
                {
                    errorBag: "assignFaculties"
                }
            ),
            photoPreview: ""
        };
    },
    methods: {
        deleteIdCard(item) {

            window.axios.post(route('administrative.branch.teacher.id_card.delete', item.faculties.id)).then((resp) => {
                item.id_card = 0;
            });
        },
        submitForm() {

            this.form.post(
                route("administrative.branch.teacher.store", this.branch.id),
                {
                    preserveScroll: true,
                    onSuccess: () => {
                        location.reload();
                        this.form.reset();
                    }
                }
            );
        },
        assignFaculties() {
            // this.selectform.faculties.map((item, i) => {
            //     item.department = item?.department;
            //     item.designation = item?.designation;
            //     item.faculties = item?.faculties;
            //     item.year = item?.year;
            //     item.duration = item?.duration;
            // });

            this.selectform.post(route('administrative.branch.teacher.update', this.branch.id), {
                preserveScroll: true,
                preserveState:true,
                onSuccess: () => {
                    location.reload();
                    this.selectform.reset()
                },
            });
        },

        addFaculty() {
            this.selectform.faculties.push({});
        },

        removeFaculty(index, _id = 0) {
            const faculty = this.selectform.faculties[index];

            this.selectform.faculties.splice(index, 1);
            if (_id) {
                console.log(_id);
                axios.delete(route('administrative.branch.teacher.delete', [this.branch.id, _id])).then((resp) => {
                    console.log('done');
                })
            }
        },

        selectNewPhoto() {
            this.$refs.photo.click();
        },

        deletePhoto() {
            this.photoPreview = null;
        },

        updatePhotoPreview() {
            const reader = new FileReader();

            reader.onload = e => {
                this.photoPreview = e.target.result;
            };

            reader.readAsDataURL(this.$refs.photo.files[0]);
        },
        showDefault() {

            this.branch.faculties.forEach(faculty => {
                console.log(faculty.branch_faculty);
                this.selectform.faculties.push({

                    department: faculty.pivot.department,
                    designation: faculty.pivot.designation,
                    faculties: {
                        id: faculty.id,
                        title: faculty.first_name + ' ' + faculty.middle_name + ' ' + faculty.last_name
                    },
                    year: {id: faculty.pivot.year, title: faculty.pivot.year},
                    duration: this.durationOptions.find((item) => item.id == faculty.pivot.duration) ?? [],
                    old_id: faculty.id,
                    id_card: faculty.pivot.id_card,

                });


                //  data.push({id: item.id, title: item.name });
            });

        }
    },
    mounted() {
        this.showDefault();
    },

    computed: {
        newFaculties() {
            var faculties = [];


            this.faculties.forEach(faculty => {
                // this.selectform.faculties.map((item, i) => {
                //   if(item.faculties.id!==faculty.id){

                //   }
                // });
                faculties.push({
                    id: faculty.id,
                    title:
                        faculty.first_name +
                        " " +
                        faculty.middle_name +
                        " " +
                        faculty.last_name
                });

            });
            return faculties;
        },

        durationOptions() {
            var data = [];
            this.duration.forEach(item => {
                data.push({id: item.id, title: item.start_month + ' - ' + item.end_month});
            });

            return data;

        },
        datesOptions() {
            var data = [];
            this.dates.forEach(item => {
                data.push({id: item.toString(), title: item.toString()});
            });
            return data;
        }
    }
};
</script>
